module.exports = __webpack_public_path__ + "images/interview-UPS-2.svg";